import { getListOfRCSPrice } from "../types/gateway_and_price_list_rcs_types";

const initState = {

  data: [],
  count: 0,
  loading: false,
  error: null,
};

export default function gatewayAndPriceListRCSReducer(state = initState, action = {}) {
  switch (action.type) {

    case getListOfRCSPrice.GET_LIST_OF_RCS_PRICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfRCSPrice.GET_LIST_OF_RCS_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        count: action.payload.count,
        error: null,

      };
    case getListOfRCSPrice.GET_LIST_OF_RCS_PRICE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
